import { Box, Tooltip } from "@mui/material";
import { Fragment } from "react";

type ApplicationTooltipProps = {
    title: React.ReactNode;
    placement?:  'right-start' | 'left-start' | 'bottom-start' | 'bottom-end' | 'top-start';
    maxWidth?: number | string;
    offset?: [number, number];
    disableInteractive?: boolean;
    children: React.ReactElement;
};

export function ApplicationTooltip({
    title,
    placement='bottom-start',
    maxWidth = 300,
    offset = [0, 2],
    disableInteractive = false,
    children,
}: ApplicationTooltipProps){
    return (
        <>
            {title ? (
                <Tooltip
                    placement={placement}
                    arrow
                    disableInteractive={disableInteractive}
                    title={
                        <Fragment>
                            <Box sx={{fontSize: "13px"}}>{title}</Box>
                        </Fragment>
                    }
                    componentsProps={{
                        tooltip: {
                            sx: {
                                maxWidth,
                            },
                        },
                    }}
                    slotProps={{
                        popper: {
                            modifiers: [
                                {
                                    name: 'offset',
                                    options: { offset },
                                },
                            ],
                        },
                    }}
                >
                    {children}
                </Tooltip>
            ) : (
                children
            )}
        </>
    )
}
